import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

export default function IsAllowed() {
	return useFeatureAvailable(Feature.COMPANY_GROUP_CARD);
}
